import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const EmptyGridCell = styled.div``

export const DepositInvoiceLineWrapper = styled.div`
  margin-top: ${Spacing.S6};
  padding-top: ${Spacing.S12};
  padding-bottom: ${Spacing.S12};
  border-top: 1px solid ${Color.Grey200};
  border-bottom: 1px solid ${Color.Grey200};

  & > div {
    align-items: center;
  }
`
